import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';

@Component({
  selector: 'select-approver',
  templateUrl: './select-approver.component.html',
  styleUrls: ['./select-approver.component.css']
})
export class SelectApproverComponent implements OnInit {
  public loading: boolean;
  public approvers: any;
  public selectedApprover: any;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
    private apiService: ApiService,
    private messageService?: NbToastrService) {
    if (config && config.data && config.data.requisitionId) {
      this.loadApprovers();
    }



  }

  ngOnInit() {
  }

  public loadApprovers() {
    this.loading = true;

    this.approvers = new Array();
    this.apiService.get(`/api/user/approvers`)
      .subscribe(results => {
        this.approvers = results;
        this.loading = false;
      }, err => {
        this.messageService.danger("Could not load", "Action");
        this.loading = false;
      });
  }


  public save() {
    this.ref.close(this.selectedApprover);
  }

  public cancel() {
    this.ref.close();
  }

}
